import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useLastVisitedEventType } from '@sorare/core/src/hooks/useLastVisitedEventType';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

import { LayoutParams } from './__generated__/routeParams';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;
const PlayProLayout = () => {
  const { eventType } = useTypedParams<LayoutParams>();
  const { lastVisitedEventType, setLastVisitedEventType } =
    useLastVisitedEventType();

  if (lastVisitedEventType !== eventType) {
    setLastVisitedEventType(eventType);
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
